module.exports = __webpack_public_path__ + "media/icons/dark-ajax-loader-02bac3c7.gif";